module.exports = __webpack_public_path__ + "img/0f7b8fae054e6625eeec917f9bedcb87.png";